import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import SideLayout from 'src/components/layouts/SideLayout';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import { updateMenu } from 'src/redux/actions/sideLayoutCreator';

const mapStateToProps = ({ sideLayoutState: { pathName }, authState: { menuItem } }: IStoreState) => ({
  pathName,
  menuItem,
});
const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    updateMenu: (pathName: string) => dispatch(updateMenu(pathName)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideLayout);



// WEBPACK FOOTER //
// ./src/containers/SideLayout.ts